import React from 'react';
import { toast, Toaster } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import userIcon from '../../assets/icon/icons8-user-48.png'
const User = () => {

    const navigate = useNavigate()
    const token = localStorage.getItem('token');

    const logOut = () => {
        fetch("https://wehatbazar.thecell.tech/api/logout", {
            method: "POST",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',

                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.json())
            .then(data => {
                // console.log(data.data)
                if (data.success === true) {
                    toast.success("Logout Successfully")
                    localStorage.removeItem('token')
                    console.log(data)
                    navigate('/')
                    localStorage.removeItem('user_id')
                } else {
                    console.log(data)
                }
            })
        localStorage.removeItem('token')
    }




    return (
        <div>
            {token && token ? (
                <div className="dropdown dropdown-end sm:hidden lg:block">
                <label tabIndex={0} className="flex btn-ghost btn-circle avatar">
                    <div className="w-10 rounded-full">
                        <img src={userIcon} className='logo' alt='something' />
                    </div>
                </label>
                <ul tabIndex={0} className="mt-3 p-2 shadow bg-blue-500 text-white menu menu-compact dropdown-content  rounded-box w-52" style={{ right: "-40px" }}>
                    <li>
                        <Link to='/Profile' className="justify-between">
                            Profile
                            <span className="badge">New</span>
                        </Link>
                    </li>
                    <li><Link to="/order-history">Order History</Link></li>
                    <li><button onClick={logOut}>Logout</button></li>
                </ul>
            </div>
            ) : ( <div>
                <Link to="/login" className='text-white'>Login</Link>
            </div>)}
            {/* <div className="dropdown dropdown-end sm:hidden lg:block">
                <label tabIndex={0} className="flex btn-ghost btn-circle avatar">
                    <div className="w-10 rounded-full">
                        <img src={userIcon} className='logo' alt='something' />
                    </div>
                </label>
                <ul tabIndex={0} className="mt-3 p-2 shadow bg-blue-500 text-white menu menu-compact dropdown-content  rounded-box w-52" style={{ right: "-40px" }}>
                    <li>
                        <Link to='/' className="justify-between">
                            Profile
                            <span className="badge">New</span>
                        </Link>
                    </li>
                    <li><Link to="/">Settings</Link></li>
                    <li><Link to='/'>Logout</Link></li>
                </ul>
                <Toaster></Toaster>
            </div> */}
            <Toaster></Toaster>
        </div>
    );
};

export default User;